import { useMutation } from "@apollo/client";
import { RegisterWithPhoneMutation, RegisterWithPhoneMutationVariables } from "@ctypes";
import { REGISTER_WITH_PHONE } from "@graphql";

export const useRegisterWithPhone = () => {
  return useMutation<RegisterWithPhoneMutation, RegisterWithPhoneMutationVariables>(
    REGISTER_WITH_PHONE,
    {
      context: {
        headers: {
          Authorization: "",
        },
      },
    },
  );
};
